import AuthService from 'services/authService';
import ManagementUserOrganizationMemberService from 'services/managementUserOrganizationMemberService';
import CacheService from 'services/cacheService';
import PermissionService from 'services/permissionService';
import OrganizationService from 'services/organizationService';
import AnalyticsService from 'services/analyticsService';
import LoggerService from 'services/loggerService';
import VenueService from 'services/venueService';
import UserPreferencesService from 'services/userPreferencesService';
import ModalService from 'services/modalService';
import OnboardingService from 'services/onboardingService';
import AlertService from 'services/alertService';
import DateUtilsService from 'services/dateUtilsService';
import AdmissionGroupLineParserService from 'services/admissionGroupLineParserService';
import PubsubService from 'services/pubsubService';
import PrintService from 'services/printService';
import TemplateService from 'services/templateService';
import UtilsService from 'services/utilsService';
import VisibilityHelpersService from 'services/visibilityHelpersService';
import UrlService from 'services/urlService';
import ColorService from 'services/colorService';
import FormHelpersService from 'services/formHelpersService';
import MapperService from 'services/mapperService';
import SupportService from 'services/supportService';
import MonthService from 'services/monthService';
import SellingOptionsHelperService from 'services/sellingOptionsHelperService';
import DocumentDownloadService from 'services/documentDownloadService';
import CountryService from 'services/countryService';
import TimezoneService from 'services/timezoneService';
import OrganizationRelationshipService from 'services/organizationRelationshipService';
import OrganizationMemberService from 'services/organizationMemberService';
import ReportService from 'services/reportService';

function init(app) {
  if (!app) throw new Error('app is required');

  app.service('authService', AuthService);
  app.service('cacheService', CacheService);
  app.service('permissionService', PermissionService);
  app.service('organizationService', OrganizationService);
  app.service('loggerService', LoggerService);
  app.service('analyticsService', AnalyticsService);
  app.service('venueService', VenueService);
  app.service('organizationRelationshipService', OrganizationRelationshipService);
  app.service('organizationMemberService', OrganizationMemberService);
  app.service('userPreferencesService', UserPreferencesService);
  app.service('managementUserOrganizationMemberService', ManagementUserOrganizationMemberService);
  app.service('modalService', ModalService);
  app.service('onboardingService', OnboardingService);
  app.service('alertService', AlertService);
  app.service('dateUtilsService', DateUtilsService);
  app.service('admissionGroupLineParserService', AdmissionGroupLineParserService);
  app.service('pubsubService', PubsubService);
  app.service('printService', PrintService);
  app.service('templateService', TemplateService);
  app.service('utilsService', UtilsService);
  app.service('visibilityHelpersService', VisibilityHelpersService);
  app.service('urlService', UrlService);
  app.service('colorService', ColorService);
  app.service('formHelpersService', FormHelpersService);
  app.service('mapperService', MapperService);
  app.service('supportService', SupportService);
  app.service('monthService', MonthService);
  app.service('sellingOptionsHelpersService', SellingOptionsHelperService);
  app.service('documentDownloadService', DocumentDownloadService);
  app.service('countryService', CountryService);
  app.service('timezoneService', TimezoneService);
  app.service('reportService', ReportService);
}

export default {
  init
};



// WEBPACK FOOTER //
// ./src/services/index.js